const state = {
  city: '',
  proMain: {},
  proAttach: {},
  insurer: {}
}

const mutations = {
  SET_CITY: (state, city) => {
    state.city = city
  },
  SET_PRO_MAIN: (state, pro) => {
    state.proMain = pro
  },
  SET_PRO_ATTACH: (state, pro) => {
    state.proAttach = pro
  },
  SET_INSURER: (state, insurer) => {
    state.insurer = insurer
  }
}

const actions = {
  setCity({ commit }, city) {
    commit('SET_CITY', city)
  },
  setProMain({ commit }, pro) {
    commit('SET_PRO_MAIN', pro)
  },
  setProAttach({ commit }, pro) {
    commit('SET_PRO_ATTACH', pro)
  },
  setInsurer({ commit }, insurer) {
    commit('SET_INSURER', insurer)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
